import dynamic from 'next/dynamic'

export const DynamicAddressModal = dynamic(() => import('.').then((mod) => mod.AddressModal), {
  ssr: false,
})
